import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M17.001 20H6.00098C4.89641 20 4.00098 19.1046 4.00098 18V7C4.00098 5.89543 4.89641 5 6.00098 5H10.001V7H6.00098V18H17.001V14H19.001V18C19.001 19.1046 18.1055 20 17.001 20ZM11.701 13.707L10.291 12.293L16.584 6H13.001V4H20.001V11H18.001V7.415L11.701 13.707Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "ExternalLink"
);
